import Vue from 'vue'
import axios from 'axios'
import App from '@/App.vue'
import router from '@/setup/router'
import store from '@/store/store'
import i18n from '@/setup/i18n'
import api from '@/setup/api.js'
import moment from 'moment'
import Notifications from 'vue-notification'
import cookieconsent from 'vue-cookieconsent-component'
import VueLazyload from 'vue-lazyload'
import Meta from 'vue-meta'


// service worker registration script (workbox-window)
import './setup/registerServiceWorker'

// foundation-zurb dependencies
import '../node_modules/jquery/dist/jquery.min.js'
import '../node_modules/what-input/dist/what-input.min.js'
import '../node_modules/motion-ui/dist/motion-ui.min.js'
import '../node_modules/foundation-sites/js/foundation.js'

// eslint-disable-next-line
import IconLibrary from '@/setup/icon-lib.js'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {EventBus} from '@/setup/event-bus.js'

// global components
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('cookie-consent', cookieconsent)

// map axios
Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.use(i18n)
Vue.use(Meta)
Vue.use(Notifications)
Vue.use(VueLazyload, {
	preLoad: 1.3,
	attempt: 1,
	error: './assets/imgs/kc-logo.png',
	listenEvents: ['scroll']
})


// custom functions, vars, mappings
Vue.use({
	install(Vue) {
		Vue.prototype.$api = api,
			Vue.prototype.$eBus = EventBus,
			Vue.prototype.requestCurrentPosition = function() {
				return new Promise((resolve, reject) => {
					if ('geolocation' in navigator) {
						navigator.geolocation.getCurrentPosition(
							(res) => {
								let pos = {
									lat: res.coords.latitude,
									lng: res.coords.longitude
								}
								resolve(pos)
							},
							(err) => {
								reject(`${err.message}`)
							})
					} else {
						reject('Location service unavailable.')
					}
				})
			},
			Vue.prototype.getDistanceToCompany = function(currentPosition, companyPosition) {
				return new Promise((resolve, reject) => {
					if (currentPosition === undefined || companyPosition === undefined || companyPosition.lat === undefined || companyPosition.lng === undefined) {
						reject(`Can't get distance: unsuported positions.`)
					}

					axios({
						method: 'get',
						url: `http://app.kaerntencard.at:5000/route/v1/driving/${currentPosition.lng},${currentPosition.lat};${companyPosition.lng},${companyPosition.lat}`
					})
						.then(response => {
							if (response.status === 200 && response.data.code === 'Ok') {
								if (response.data.routes.length >= 1 && response.data.routes[0] !== undefined) {
									let distance = response.data.routes[0].distance
									resolve(distance)
								}
							} else {
								// reject the promise due to error
							}
						})
						.catch(err => {
							reject(err)
							console.error(err)
						})
				})
			},
			Vue.prototype.ucFirst = function(string) {
				return string.charAt(0).toUpperCase() + string.slice(1)
			},
			Vue.prototype.getCurrentSeason = function() {
				let currentYear = moment().year()
				let season = (moment().isBetween(`${currentYear}-04-02`, `${currentYear}-10-31`)) ? 'sommer' : 'winter'
				return season
			},
			Vue.prototype.checkVersion = function() {
				return new Promise((resolve, reject) => {
					axios({
						method: 'get',
						url: '/version.json'
					})
						.then((response) => {
							if (response.status === 200 && response.data) {
								resolve(response.data)
							}
						})
						.catch((error) => {
							console.error(error)
							reject(error)
						})
				})
			},
			Vue.prototype.mapLink = function(lat, lng, title = "") {
				if (
					(navigator.platform.indexOf("iPhone") != -1) ||
					(navigator.platform.indexOf("iPad") != -1) ||
					(navigator.platform.indexOf("iPod") != -1)
				) {
					return `maps://maps.google.com/maps?daddr=${lat},${lng}&ll=${title}`
				} else {
					return `https://maps.google.com/maps?daddr=${lat},${lng}&ll=${title}`
				}
			};
	}
})

Vue.filter('imageproxy', function(value, size) {
	if (!value) return ''
	// console.log('imageproxy',value, size)
	return value.replace('https://www.kaerntencard.at', 'https://app.kaerntencard.at/media/' + size)
})

Vue.filter('sanitizedDescription', function(value) {
	if (!value) return ''
	return value.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 160) + '...'
})

Vue.filter('normalizePhoneNumber', function(value) {
	if (!value) return ''
	return value.replace(/\(?[0]\)?/, ' ').replace(/\//g, ' ').replace(/-/g, ' ')
})

const myMixin = {
	methods: {
		formatUrl(url) {
			if (!url.startsWith("http")) {
				url = "https://" + url
			}
			return url
		}
	}
}


new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
	mixins: [myMixin]
}).$mount('#app')

//Import Category Colorization
import './setup/category-colorization'

